import {createGlobalStyle} from 'styled-components'
import {RebootStyles} from './global/reboot.styled'

export const GlobalStyles = createGlobalStyle`
  ${RebootStyles}
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Globals */
  body, html {
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-size: 14px;

    @media (max-width: 1024px) { /* Equivalent to @include large */
      font-size: 14px;
    }

    @media (max-width: 768px) { /* Equivalent to @include medium */
      font-size: 13px;
    }
  }

  #root {
    scroll-behavior: smooth;
    min-height: 100vh;
    background-color: #e7e7e7; /* $background-color */
  }

  .root--selected-location {
    background-color: #b3b3b3 !important; /* $dark-grey-30 */
  }

  .tippy-box, .tippy-content {
    padding: 0 !important;
    background: none;
  }

  @keyframes loading-indicator {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  
`
